import React from "react";
import { useNavigate } from "react-router-dom";
import useScrollToTop from "../../scrollhooks";

const ServiceHome = () => {
  useScrollToTop();
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto py-10">
        <h2 className="font-Inter font-bold text-4xl text-background text-center py-5">
          Our Services
        </h2>
        <div className="flex justify-between items-center flex-col lg:flex-row py-6 gap-4">
          <div className="relative bg-haulageBg bg-cover bg-center bg-no-repeat rounded-md w-[340px] sm:w-[350px] md:w-[400px] xl:w-[420px] h-[400px]">
            <div className="absolute top-0 left-0 w-full h-full rounded-md flex justify-end items-center bg-black opacity-70">
              <div className="w-[330px] mx-auto">
                <h2 className="font-bold text-white font-Poppins py-4 lg:pl-4 text-3xl">
                  Haulage and Removal
                </h2>
                <p className="text-white font-medium lg:pl-4">
                  We are a premier Haulage and Removal company offering
                  comprehensive freight transportation solutions from start to
                  finish.
                </p>
                <div className="w-[300px] my-6 lg:pl-4">
                  <button
                    onClick={() => handleNavigate("/haulage")}
                    className="bg-white font-semibold text-black font-Urbanist p-3 rounded-lg hover:bg-navBg"
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="relative bg-drainBg bg-cover bg-center bg-no-repeat rounded-md w-[340px] sm:w-[350px] md:w-[400px] xl:w-[420px] h-[400px]">
            <div className="absolute top-0 left-0 w-full h-full rounded-md flex justify-end items-center bg-black opacity-70">
              <div className="w-[330px] lg:w-[300px] mx-auto">
                <h2 className="font-bold text-white font-Poppins py-4 lg:pl-4 text-3xl">
                  Drain Unblocking
                </h2>
                <p className="text-white font-medium lg:pl-4">
                  All that goes through your drain travel a long distance before
                  getting into the wastewater treatment plant
                </p>
                <div className="w-[300px] my-6 lg:pl-4">
                  <button
                    onClick={() => handleNavigate("/drain-unblocking")}
                    className="bg-white font-semibold text-black font-Urbanist p-3 rounded-lg hover:bg-navBg"
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="relative bg-kitchenBg bg-cover bg-center bg-no-repeat rounded-md w-[340px] sm:w-[350px] md:w-[400px] xl:w-[420px] h-[400px]">
            <div className="absolute top-0 left-0 w-full h-full rounded-md flex justify-end items-center bg-black opacity-70">
              <div className="w-[330px] mx-auto">
                <h2 className="font-bold text-white font-Poppins py-4 lg:pl-4 text-3xl">
                  Kitchen & Plumbing
                </h2>
                <p className="text-white font-medium lg:pl-4">
                  PMC offers unsurpassed plumbing expertise at affordable
                  prices. Our service offering covers general household
                  plumbing, maintenance, drain…
                </p>
                <div className="w-[300px] my-6 lg:pl-4">
                  <button
                    onClick={() => handleNavigate("/kitchen")}
                    className="bg-white font-semibold text-black font-Urbanist p-3 rounded-lg hover:bg-navBg"
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHome;
